var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objects-list"},_vm._l((_vm.listData),function(card){return _c('ObjectsCard',{key:card.id,attrs:{"card":card,"activeTab":_vm.activeTab},on:{"showOwners":_vm._showOwners}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }